module.exports = __webpack_public_path__ + "img/f6.9fedf2f6.png";